import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import { makeStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
    root: { marginTop: 0, marginRight: 0 },
    formControlLabelRoot: {
        marginRight: 0,
        [theme.breakpoints.down("sm")]: {
            marginRight: theme.spacing(2),
        },
    },
    formControlLabelCheckBox: {
        paddingTop: "2px",
        paddingBottom: "2px",
        paddingRight: "2px",
    },
    formControlLabel: {
        ...theme.typography.h4,
        margin: theme.spacing(0.5, 0),
    },
}));

export default function CheckBoxGroup({
    onCheck,
    checkBoxOptions,
    resetSelectedOptions,
    defaultSelectedOptions,
}) {
    const classes = useStyles();

    const initCheckBoxOptions = () => {
        return checkBoxOptions.reduce((acc, option) => {
            const name = option.toLowerCase().replace(/ /g, "-");
            return {
                ...acc,
                [name]: {
                    value: option,
                    name,
                    selected: isEmpty(defaultSelectedOptions)
                        ? false
                        : defaultSelectedOptions.includes(option),
                },
            };
        }, {});
    };

    const [options, setOptions] = React.useState(initCheckBoxOptions());

    const handleChange = (event) => {
        options[event.target.name].selected = event.target.checked;
        setOptions({ ...options });
        onCheck(options);
    };

    React.useEffect(() => {
        if (resetSelectedOptions) {
            const unselectedOptions = initCheckBoxOptions();
            setOptions(unselectedOptions);
        }
    }, [resetSelectedOptions]);

    return (
        <FormGroup row className={classes.root}>
            {Object.values(options).map((option, index) => (
                <Box key={index} width="100%">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={option.selected}
                                onChange={handleChange}
                                name={option.name}
                                size={"small"}
                                color="primary"
                                className={classes.formControlLabelCheckBox}
                            />
                        }
                        classes={{ root: classes.formControlLabelRoot, label: classes.formControlLabel }}
                        label={option.value}
                    />
                </Box>
            ))}
        </FormGroup>
    );
}

CheckBoxGroup.propTypes = {
    onCheck: PropTypes.func,
    checkBoxOptions: PropTypes.array,
    defaultSelectedOptions: PropTypes.array,
    resetSelectedOptions: PropTypes.bool,
};
CheckBoxGroup.defaultProps = {
    onCheck: () => {},
    resetSelectedOptions: false,
};
